import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "slide-drawer-panel" };
const _hoisted_2 = { class: "slide-drawer-title" };
const _hoisted_3 = { class: "slide-drawer-content" };
import { computed, getCurrentInstance } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'SlideDrawer',
    props: {
        modelValue: { type: Boolean },
        title: {}
    },
    emits: ["update:modelValue", "back"],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        const instance = getCurrentInstance();
        const cookies = instance?.appContext.config.globalProperties.$cookies;
        const safeTop = computed(() => {
            return parseInt(cookies?.get('st') ?? '0');
        });
        function close() {
            emit('update:modelValue', false);
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
                _createVNode(_Transition, { name: "slide-drawer" }, {
                    default: _withCtx(() => [
                        (_ctx.modelValue)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "slide-drawer-overlay",
                                onClick: _withModifiers(close, ["self"])
                            }, [
                                _createElementVNode("div", _hoisted_1, [
                                    _createElementVNode("div", {
                                        class: "slide-drawer-header",
                                        style: _normalizeStyle({ paddingTop: (16 + safeTop.value) + 'px' })
                                    }, [
                                        _createElementVNode("div", {
                                            class: "header-btn",
                                            onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('back')))
                                        }, [
                                            _renderSlot(_ctx.$slots, "back-button", {}, () => [
                                                _cache[1] || (_cache[1] = _createElementVNode("span", null, null, -1))
                                            ])
                                        ]),
                                        _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.title), 1),
                                        _createElementVNode("div", {
                                            class: "header-btn",
                                            onClick: close
                                        }, "✕")
                                    ], 4),
                                    _createElementVNode("div", _hoisted_3, [
                                        _renderSlot(_ctx.$slots, "default")
                                    ])
                                ])
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _: 3
                })
            ]));
        };
    }
});
